import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateScorecardMutationVariables = Types.Exact<{
  input: Types.CreateScorecardInput;
}>;


export type CreateScorecardMutation = { createScorecard: { success?: boolean | null, errorCode?: string | null, scorecard?: { id: string, title: string, questions?: Array<{ text: string, maxScore: number, id: string }> | null } | null } };


export const CreateScorecardDocument = /*#__PURE__*/ gql`
    mutation createScorecard($input: CreateScorecardInput!) {
  createScorecard(data: $input) {
    success
    errorCode
    scorecard {
      id
      title
      questions {
        text
        maxScore
        id
      }
    }
  }
}
    `;

export function useCreateScorecardMutation() {
  return Urql.useMutation<CreateScorecardMutation, CreateScorecardMutationVariables>(CreateScorecardDocument);
};